(function() {
  function initFooterNewsletter() {
    try {
      const form = document.getElementById('FooterCustomSignup');
      if (!form) return;

      if (form.__klaviyoBound) return;
      form.__klaviyoBound = true;

      const klForm = document.createElement('form');
      klForm.style.display = 'none';
      klForm.action = 'https://manage.kmail-lists.com/subscriptions/subscribe';
      klForm.method = 'POST';
      klForm.target = 'klaviyo-subscribe-iframe';

      const g = document.createElement('input');
      g.type = 'hidden'; g.name = 'g'; g.value = 'XetNSi';
      klForm.appendChild(g);

      const emailField = document.createElement('input');
      emailField.type = 'hidden'; emailField.name = 'email';
      klForm.appendChild(emailField);

      const fields = document.createElement('input');
      fields.type = 'hidden'; fields.name = '$fields'; fields.value = 'source';
      klForm.appendChild(fields);

      const source = document.createElement('input');
      source.type = 'hidden'; source.name = 'source'; source.value = 'footer';
      klForm.appendChild(source);

      document.body.appendChild(klForm);

      let klSubmitted = false;
      form.addEventListener('submit', function() {
        const emailInput = document.getElementById('FooterCustomSignup-email');
        const email = emailInput && emailInput.value ? emailInput.value.trim() : '';
        if (!email || klSubmitted) return;
        klSubmitted = true;
        emailField.value = email;
        klForm.submit();
        setTimeout(function(){ klSubmitted = false; }, 2000);
      });
    } catch (e) { /* noop */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterNewsletter);
  } else {
    initFooterNewsletter();
  }
})();
